/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-certificate-popup',
  templateUrl: './certificate-popup.component.html'
})
export class CertificatePopupComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  activeSignature: any;

  ngOnInit(): void {
  }

}
